const lockBodyScroll = (): void => {
    document.body.style.overflow = 'hidden';
};

const unlockBodyScroll = (): void => {
    document.body.style.removeProperty('overflow');
};

export { lockBodyScroll, unlockBodyScroll };
